import React from 'react';

const sizeToPx = value => {
    if (typeof value === 'number') return `${value}px`;
    return value || '48px';
};

const LoadingSpinner = ({
    color = '#ffffff',
    width = 48,
    height = 48,
    className,
    style,
    label = 'Loading',
}) => {
    const resolvedWidth = sizeToPx(width);
    const resolvedHeight = sizeToPx(height);

    return (
        <div
            className={className}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: resolvedWidth,
                height: resolvedHeight,
                ...style,
            }}
            role="status"
            aria-label={label}
        >
            <svg
                viewBox="0 0 50 50"
                width={resolvedWidth}
                height={resolvedHeight}
                aria-hidden="true"
            >
                <circle
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke="rgba(255,255,255,0.18)"
                    strokeWidth="4"
                />
                <circle
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke={color}
                    strokeLinecap="round"
                    strokeWidth="4"
                    strokeDasharray="90 150"
                >
                    <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        dur="0.85s"
                        from="0 25 25"
                        repeatCount="indefinite"
                        to="360 25 25"
                        type="rotate"
                    />
                </circle>
            </svg>
        </div>
    );
};

export default LoadingSpinner;
